exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1RQxL1tesVsnxO{background-color:#97a0af;border-radius:3px;color:#fff;font-weight:700;margin-top:4px;overflow:hidden;padding:4px 8px;box-shadow:0 20px 32px -8px rgba(9,30,66,.25),0 0 0 1px rgba(9,30,66,.08)}._1RQxL1tesVsnxO.sUsGnBcdmbkufO{background-color:#fff;color:#172b4d}._1RQxL1tesVsnxO._2fngKZeL-w7kjH{background-color:#ff9f1a;color:#172b4d}._1RQxL1tesVsnxO._1eJv7zl3jGLuHb{background-color:#eb5a46}._1RQxL1tesVsnxO._2W_4oKtH17TDM6,._1RQxL1tesVsnxO.RAdHOoXE4kmV1M{background-color:#61bd4f}._1RQxL1tesVsnxO._2pQ9SS0gfag7Jq{background-color:#42526e}", ""]);

// exports
exports.locals = {
	"appAlertItem": "_1RQxL1tesVsnxO",
	"neutral": "sUsGnBcdmbkufO",
	"warning": "_2fngKZeL-w7kjH",
	"error": "_1eJv7zl3jGLuHb",
	"info": "RAdHOoXE4kmV1M",
	"confirm": "_2W_4oKtH17TDM6",
	"subtle": "_2pQ9SS0gfag7Jq"
};